import { Container, Row, Col } from "reactstrap";
import Link from "next/link";
import styles from "./styles.module.scss";

export const MainBanner = ({
  className,
  title,
  titleColour,
  content,
  image,
  returnLinkURL,
  returnLinkTitle,
  buttonLink,
  buttonTitle,
  buttonNewTab,
}) => {

  return (
    <section className={`${styles.root} ${className}`}>
      <Container>
        <Row className="m-0">
          <Col lg={6} className="contentWrapper d-flex flex-wrap align-items-center position-relative">
            <div>
              {returnLinkURL &&
                <Link href={returnLinkURL}>
                  <a className="return-text text-nowrap arrow-left d-inline-flex align-items-center white mb-4"><strong>{returnLinkTitle}</strong></a>
                </Link>
              }
              <h1 className={`text-${titleColour?.variant}`} style={{color: titleColour?.custom}}>{title}</h1>
              {content &&
                <div className="mt-4" dangerouslySetInnerHTML={{ __html: content }} />
              }
              {buttonLink && buttonTitle &&
                <div className="mt-4">
                  <a href={buttonLink} className={`fourthBtn no-arrow m-0`} target={buttonNewTab ? '_blank' : '_self'}>
                    {buttonTitle}
                  </a>
                </div>
              }
            </div>
          </Col>
          <figure className="imageWrapper position-absolute p-0 m-0">
            <img src={image?.url ? image?.url : "/site-assets/images/sub-banner-about-us.png"} alt={image?.alt} loading="eager" className="card-img rounded-0" />
          </figure>
        </Row>
      </Container>
    </section>
  );

}

export default MainBanner;
